import { render } from "./MainFooter.vue?vue&type=template&id=2b63903a&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=2b63903a&scoped=true&lang=css"

import exportComponent from "/Users/yourkesa/Downloads/qron_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b63903a"]])

export default __exports__